import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { masterApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { updateMaster } = useAuth();
  const cancelled = location.pathname.includes("cancel");
  const [status, setStatus] = useState(cancelled ? "cancel" : "checking");

  useEffect(() => {
    if (cancelled) return;
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await masterApi.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { updateMaster({ subscription_status: "active" }); setStatus("paid"); return; }
        if (data.status === "expired" || tries > 10) { setStatus("error"); return; }
      } catch { /* retry */ }
      tries += 1; setTimeout(poll, 2000);
    };
    poll();
  }, [cancelled, params, updateMaster]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-5">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-8 shadow-xl text-center space-y-4">
        {status === "checking" && <><Loader2 className="w-12 h-12 text-blue-600 mx-auto animate-spin" /><p className="text-slate-600">Confirming your subscription…</p></>}
        {status === "paid" && <><CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" /><h1 className="text-xl font-extrabold text-slate-900">Subscription Active!</h1><p className="text-slate-500 text-sm">Your ZapBasket subscription is now active.</p></>}
        {status === "cancel" && <><XCircle className="w-12 h-12 text-amber-500 mx-auto" /><h1 className="text-xl font-extrabold text-slate-900">Payment cancelled</h1></>}
        {status === "error" && <><XCircle className="w-12 h-12 text-red-500 mx-auto" /><h1 className="text-xl font-extrabold text-slate-900">Could not confirm payment</h1></>}
        <Button data-testid="payment-continue" onClick={() => navigate("/staff")} className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-semibold">Continue to ZapBasket</Button>
      </div>
    </div>
  );
}
